import { render, staticRenderFns } from "./ActividadBarraAvance.vue?vue&type=template&id=0f46c2f7&scoped=true&"
import script from "./ActividadBarraAvance.vue?vue&type=script&lang=js&"
export * from "./ActividadBarraAvance.vue?vue&type=script&lang=js&"
import style0 from "./ActividadBarraAvance.vue?vue&type=style&index=0&id=0f46c2f7&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f46c2f7",
  null
  
)

export default component.exports